import { TStickyPanel } from 'widgets/search/StickyPanel';
import { getHeaderHeight } from '../utils';

/**
 * @param Widget Base widget for extending
 * @returns CoreStickyPanel widget
 */
function CoreStickyPanelClassCreator(StickyPanel: TStickyPanel) {
    /**
     * @category widgets
     * @subcategory search
     * @class CoreStickyPanel
     * @augments StickyPanel
     * @classdesc StickyPanel helper. Should be on element before StickyPanel to observe intersection
     * The main purpose is to define anchor for StickyPanel and toggle StickyPanel.
     *
     * @example <caption>Example of StickyPanel widget usage</caption>
     * <div data-widget="stickyPanel"></div>
     */
    class CoreStickyPanel extends StickyPanel {
        /**
         * @description IntersectionObserver initialization
         */
        initObserver() {
            const stickyPanel = this.ref('self').get();

            if (!stickyPanel) {
                return;
            }

            if (this.observer) {
                this.destroy();
            }

            const headerHeight = getHeaderHeight();

            this.headerHeight = String(headerHeight);

            this.observer = new IntersectionObserver(([entry]) => this.toggleStickyState(entry), {
                rootMargin: `-${headerHeight}.1px 0px 0px 0px`,
                threshold: 1
            });

            this.observer?.observe(stickyPanel);
        }
    }

    return CoreStickyPanel;
}

export type TCoreStickyPanel = ReturnType<typeof CoreStickyPanelClassCreator>;

export type TCoreStickyPanelInstance = InstanceType<TCoreStickyPanel>;

export default CoreStickyPanelClassCreator;
